export default "__VITE_ASSET__CKo$CLeN__"